import { BrandEnum }           from '@core/services/brand/brand.enums';
import {
	ENVIRONMENT_BASE_URL,
	EnvironmentEnum,
	IEnvironmentConfig
}                              from '@env/environment.model';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js';

const resolveBaseUrl = (): ENVIRONMENT_BASE_URL => {
	const currentUrl: string = window.location.origin;
	if ( currentUrl.includes( '-ops' ) ) {
		return ENVIRONMENT_BASE_URL.DF_UNSTABLE_OPS;
	} else if ( currentUrl.includes( '-aks' ) ) {
		return ENVIRONMENT_BASE_URL.DF_UNSTABLE_AKS;
	}
	return ENVIRONMENT_BASE_URL.DF_UNSTABLE;
};

const environmentBaseUrl: ENVIRONMENT_BASE_URL = resolveBaseUrl();

export const environment: IEnvironmentConfig = {
	activeEnvironment: EnvironmentEnum.UNSTABLE,
	brandData: {
		activeBranding: BrandEnum.DeutscheFiskal
	},
	devModules: [
		StoreDevtoolsModule.instrument( {
			maxAge: 25
		} )
	],
	envBaseUrl: environmentBaseUrl,
	features: {
		elster: {
			enabled: true
		},
	},
	keycloak: {
		url: `${ environmentBaseUrl }/auth/`,
		realm: 'df',
		clientId: 'df-frontend'
	},
	production: false,
	unstableBaseUrl: ENVIRONMENT_BASE_URL.DF_UNSTABLE,
	useMockRequest: true
	// useMockRequest: isMockRequestNeeded( false ),
};

/*
 * NOTE: using `isMockRequestNeeded()` and uncommenting the corresponding code
 * sections below will result in a ReferenceError "can't access lexical declaration
 * 'APP_CONFIG' before initialization" when the application starts (circular reference?)
 */
// export function isMockRequestNeeded( defaultFlag: boolean ): boolean {
// 	if ( !KEYCLOACK_CONFIG.useKeycloakService ) { return true; }
// 	return forceUseMockRequestsWhenEntitiesUseLocalPathApiCalls( defaultFlag );
// }
//
// export function forceUseMockRequestsWhenEntitiesUseLocalPathApiCalls( defaultFlag: boolean ): boolean {
// 	const checkResult = Object.values( API_CONFIG.entities ).some( entity => entity.useLocalPath );
// 	return checkResult ? true : defaultFlag;
// }
